
import { DisputedTranService } from "@/services/disputed"
import style from './style.module.scss'
import { Button, Card, Collapse, Drawer, Flex, Skeleton, Space, Tag } from "antd"
import { useEffect, useMemo, useState } from "react"
import { CloseCircleFilled, SafetyCertificateFilled, WarningFilled } from "@ant-design/icons"
import dayjs, { DateFormate } from "@/util/params"
import { SuspiciousTranService } from "@/services/suspicios"
import { ComplaintDetailData } from "./complaintDetailData"
import { useLocation, useNavigate, useSearchParams } from "@modern-js/runtime/router"
import { ChargebackDetailPage } from "@/components/pages/global/complaint-detail-page"
import { ComplaintsService } from "@/services/complaints"
import { GlobalStore } from "@/stores/global"



export const TransactionDetailDrawer = () => {
    const globalStore = GlobalStore.useContainer()
    const uLocation = useLocation()
    const navigate = useNavigate()
    const [refreshTransaction, setRefreshTransaction] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any>(null);
    const [searchParams, setSearchParams] = useSearchParams();

    const bstTransactionID = useMemo(() => {
        let id = searchParams.get("bst_transaction_id")
        return id

    }, [searchParams.get("bst_transaction_id")])

    let pathName = uLocation.pathname
    const keyIntoLabel: any = {
        transaction_id: "Transaction ID",
        transaction_amount: "Transaction Amount",
        transaction_category: "Transaction Category",
        toll_plaza: "Toll Plaza",
        lane_number: "Lane Number",
        transaction_date_time: "Transaction Date",
        transaction_status: "Transaction Status",
        on_off_us: "OnUs/OffUs",
        plaza_id: "Toll Plaza ID",
        toll_state: "Toll State",
        rrn: "RRN",
        lane_direction: "Lane Direction",
        toll_type: "Toll Type",
        tag_status: "Tag Status",
        vehicle_registration_number: "Vehicle Number",
        vehicle_class: "Vehicle Class",
        tag_id: "Tag Id"
    };

    const debitCreditkeyLabel: any = {
        rrn: "RRN",
        transaction_amount: "Transaction Amount",
        transaction_date_time: "Adjustment Date",
        partial_or_full: "Partial / Full",
        adjustment_reason: "Adjustment Reason",
        category: "Category",
        bst_transaction_id: "bst_transaction_id"
    };


    const complaintFieldMap = {
        created_date: "Chargeback Date",
        reason_code: "Chargeback Reason",
        dispute_amount: "Dispute Amount",
        partial_dispute: "Partial Dispute",

    };
    const [complaintDetailData, setComplaintDetailData] = useState<any>([])
    const [empty, setEmpty] = useState(false)

    const init = () => {
        setLoading(true);
        setEmpty(false)
        let id = `${bstTransactionID}`
        let path = pathName == '/transactions/dispute';
        if (!!!id) return
        if (!path) {
            SuspiciousTranService.getTransactionData(id).then((res) => {
                setLoading(false)
                setData(res.data);
                if (!!id) {

                    globalStore.enableChargebackButton(bstTransactionID, "transaction")
                }
            }).catch((err) => {
                setEmpty(true)
                setLoading(false)
                console.error(err);
            })
            SuspiciousTranService.getComplaintDetail(id).then((res) => {
                let datas = res.data.complaints;
                setComplaintDetailData(datas)
            }).catch((err) => {
                setLoading(false)
                console.error(err);
            })
        } else {
            DisputedTranService.getDisputetransaction(id).then((res) => {
                setLoading(false)
                setData(res.data);
                if (!!id) {

                    globalStore.enableChargebackButton(bstTransactionID, "transaction")
                }
            }).catch((err: any) => {
                setLoading(false);
                console.error(err);

            })

        }
    }
    useEffect(() => {

        if (!!searchParams.get("bst_transaction_id")) {
            init();
        }

        return () => {
            setData(null);
            // setComplaintDetailData([]);
        }

    }, [searchParams.get("bst_transaction_id"), refreshTransaction])




    const transActionList = !!data ? Object.entries(data?.transaction || {}).map(([key, value]) => ({
        key,
        value
    })) : [];



    const formatValue = (key: string, value: any) => {
        if (key === "transaction_amount") return `${value?.amount} ${value?.currency_symbol}`;
        if (key === "transaction_date_time") return dayjs(value).format("DD/MM/YYYY HH:mm:ss");
        if (key === "tag_status") {
            if (value == "A") {
                return "Active"
            } else {
                return "InActive"
            }
        };
        return value || "-";
    };

    const iconCheck = useMemo(() => {

        switch (data?.transaction?.transaction_category) {
            case "disputed":
                return <CloseCircleFilled style={{ color: "red" }} />
            case "verified":
                return <SafetyCertificateFilled color="#52C41A" style={{ color: "#52C41A" }} />
            case "suspicious":
                return <WarningFilled style={{ color: "hsl(47.36deg 100% 47.45%)", }} />
            default:
                ""
        }

    }, [data?.transaction?.transaction_category])


    const [show, setShow] = useState(false)
    let categoryType = data?.transaction?.transaction_category;

    const eligibleAmountEnable = useMemo(() => globalStore.eligibleAmount?.eligible_amount?.amount === 0, [globalStore.eligibleAmount]);
    const adjustmentEligibleAmountEnable = useMemo(() => globalStore.adjustmentEligibleAmount?.eligible_amount?.amount === 0, [globalStore.adjustmentEligibleAmount]);

    const type = searchParams.get("type");
    return (searchParams.get("bst_transaction_id") ?
        <div>
            <Drawer
                open={!!searchParams.get("bst_transaction_id")}
                onClose={() => {
                    // props.onClose();
                    let path = uLocation.pathname
                    searchParams.delete("bst_transaction_id")
                    let url = `${path}?${searchParams.toString()}`
                    navigate(url);
                }}
                title={
                    !!data?.transaction ?
                        <div style={{ display: "flex", alignItems: "center", gap: 15 }}>
                            <h3 style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                {data?.transaction?.transaction_id}
                                {iconCheck}
                            </h3>
                            <Tag
                                style={{ color: "#F5222D", borderColor: "#FFA39E" }}
                            >
                                {data?.transaction?.transaction_type}
                            </Tag>
                        </div> : empty ? "Error" : ""


                }
                placement="right"
                width={"639px"}
            >
                {empty ?
                    <Card style={{ boxShadow: "none", textTransform: "capitalize" }}>
                        transactions not found
                    </Card> : <></>}
                {!!loading ?
                    <Skeleton active paragraph={{ rows: 6 }} /> : (
                        <div style={{ position: "relative" }}>
                            {
                                data?.transaction?.transaction_category == "suspicious" ?
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px", border: "1px solid #FFE58F", padding: 5, background: "#FFFBE6" }}>
                                        <WarningFilled style={{ color: "hsl(47.36deg 100% 47.45%)", }} />
                                        <span style={{ color: "#AD6800" }}>
                                            {
                                                !!complaintDetailData && complaintDetailData.length > 0 ? complaintDetailData[0]?.banner_msg : ""
                                            }
                                        </span>
                                    </div>
                                    : ""
                            }
                            <div className={style.transwrapper}>
                                {
                                    !!data?.transaction ? <div className="">
                                        <div className="">
                                            <h3>Transaction Information</h3>
                                            <div className={style.trans}>
                                                {transActionList
                                                    .filter(
                                                        (e: any) =>
                                                            !["transaction_type", "lane_id", "adjustment_info", "tag_status", "vehicle_registration_number", "vehicle_class", "tag_id", "bst_transaction_id"].includes(e.key)
                                                    )
                                                    .map((e: any, i: number) => (
                                                        <div key={i} className={style.key}>
                                                            <div className={style.label}>{keyIntoLabel[e.key]}</div>
                                                            <span style={{ color: "#333333", textTransform: "capitalize" }}>
                                                                {formatValue(e.key, e.value)}
                                                            </span>
                                                        </div>
                                                    ))}


                                            </div>
                                        </div>


                                        <div >
                                            <h3>Vehicle Information</h3>
                                            <div className={style.trans}>
                                                {transActionList
                                                    .filter(
                                                        (e: any) =>
                                                            ["vehicle_registration_number", "tag_id", "vehicle_class", "tag_status"].includes(e.key)
                                                    )
                                                    .map((e: any, i: number) => (
                                                        <div key={i} className={style.key}>
                                                            <div className={style.label}>{keyIntoLabel[e.key]}</div>
                                                            <span style={{ color: "#333333" }}>
                                                                {formatValue(e.key, e.value)}
                                                            </span>
                                                        </div>
                                                    ))}

                                            </div>
                                        </div>
                                    </div>
                                        : ""
                                }




                            </div>
                            {/* Debit / Credit Adjustment */}
                            <Space direction="vertical" style={{ paddingBottom: "2rem" }}>
                                {Array.isArray(data?.transaction?.adjustment_info) &&
                                    data?.transaction.adjustment_info.length > 0 && (
                                        <>
                                            <div style={{ paddingTop: "10px", fontWeight: "500" }}>
                                                Adjustments
                                            </div>

                                            <div className={style.debit} >
                                                {data?.transaction.adjustment_info
                                                    .map((item: any, i: number) => {
                                                        return (
                                                            <Space key={i} direction="vertical" style={{ paddingBottom: "1rem" }}
                                                                onClick={() => globalStore.adjustmentEnableChargebackButton(item?.bst_transaction_id, "adjustment")}>
                                                                <Collapse
                                                                    collapsible="header"
                                                                    defaultActiveKey={[]}
                                                                    style={{ width: "579px" }}
                                                                    items={[
                                                                        {
                                                                            key: i,
                                                                            label: <Flex justify="space-between" align="center" gap={60}>
                                                                                <div
                                                                                    style={{
                                                                                        border: "1px solid",
                                                                                        borderColor:
                                                                                            item?.transaction_type === 'DEBIT' ? '#FFA39E' : '#B7EB8F',
                                                                                        color:
                                                                                            item?.transaction_type === 'DEBIT' ? '#F5222D' : '#52C41A',
                                                                                        padding: "1px 7px"
                                                                                    }}
                                                                                >
                                                                                    {item?.transaction_type}
                                                                                </div>

                                                                                <div>
                                                                                    {`${item?.transaction_amount?.amount}   ${item?.transaction_amount?.currency_symbol}`}
                                                                                </div>

                                                                                <div>
                                                                                    {dayjs(item?.transaction_date_time).format("DD/MM/YYYY HH:mm:ss")}
                                                                                </div>
                                                                            </Flex>,

                                                                            children: (
                                                                                <Space direction="vertical" style={{ width: "100%" }}>
                                                                                    <div key={i} className={style.adjustmentItem}>
                                                                                        {Object.entries(item)
                                                                                            .filter(([key]) => !["transaction_type", "category", "bst_transaction_id"].includes(key))
                                                                                            .map(([key, value]: [string, any], j: number) => (
                                                                                                <div key={j} className={style.key}>
                                                                                                    <div className={style.label}>
                                                                                                        {debitCreditkeyLabel[key] || key}
                                                                                                    </div>
                                                                                                    <span style={{ color: "#333333", textTransform: "capitalize" }}>
                                                                                                        {formatValue(key, value)}
                                                                                                    </span>
                                                                                                </div>
                                                                                            ))}
                                                                                    </div>

                                                                                    <div>
                                                                                        <Button
                                                                                            size="large"
                                                                                            style={{ background: "#1890FF", color: "#fff" }}
                                                                                            className={adjustmentEligibleAmountEnable ? style.disable : ""}
                                                                                            onClick={() => {
                                                                                                setShow(true)
                                                                                                searchParams.set("type", "adjustment")
                                                                                                searchParams.set("adjustment_bst_transaction_id", item?.bst_transaction_id);
                                                                                                navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true })
                                                                                            }}
                                                                                        >
                                                                                            Create New Chargeback
                                                                                        </Button>
                                                                                    </div>
                                                                                </Space>
                                                                            ),
                                                                        },
                                                                    ]}
                                                                />
                                                            </Space>

                                                        )
                                                    }
                                                    )}
                                            </div>
                                        </>

                                    )}
                            </Space>
                            <div >
                                {data?.complaints?.length > 0 && (
                                    <ComplaintDetailData
                                        complaint={data.complaints}
                                        complaintFieldMap={complaintFieldMap}
                                        dateFormate={DateFormate}
                                    />
                                )}
                            </div>


                            {/* Non-editable complaint detail */}
                            {complaintDetailData?.length > 0 &&
                                complaintDetailData.map((complaint: any, i: number) => (
                                    <div className="">
                                        {complaint.status !== "pending" && (
                                            <ComplaintDetailData
                                                complaint={complaint}
                                                complaintFieldMap={complaintFieldMap}
                                                dateFormate={DateFormate}
                                            />
                                        )}
                                    </div>

                                ))}


                        </div>


                    )}


                {
                    !!show ?
                        <ChargebackDetailPage
                            type={pathName == "/transactions/bulk" ? "bulk" : "transaction"}
                            open={!!show}
                            onClose={() => {
                                setRefreshTransaction(refreshTransaction + 1);
                                setShow(false)
                                setSearchParams((prev) => {
                                    prev.delete("type");
                                    return prev;
                                });
                            }}
                            transactionId={data?.transaction}
                            adjustmentType={type}

                        /> : ""
                }

                <div style={{ position: "fixed", bottom: -20, backgroundColor: "#ffffff", width: "588px" }}>
                    <div style={{ padding: "10px 0px 40px" }}>
                        <Button
                            size="large"
                            style={{ background: "#1890FF", color: "#fff" }}
                            className={eligibleAmountEnable && categoryType !== "suspicious" ? style.disable : ""}
                            onClick={() => {
                                setShow(true)

                            }}
                        >
                            {
                                categoryType == "suspicious" ? "Review Suspicious & Proceed" : "Create New Chargeback"
                            }
                        </Button>
                    </div>
                </div>
            </Drawer>
        </div> : <></>
    )
}





